import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const TotalsTable = ({
  ticketTypes,
  ticketReservation,
  addOns
}) => (
  <div>
    {Object.keys(ticketReservation).length > 0 ? (
      <div className="row">
        <div className="col-12">
          <p style={{"fontSize": "18px", "marginTop": "20px", "marginBottom": "15px"}}>
            <strong>Order Summary</strong>
          </p>
          {ticketTypes.filter((ti) => ti.quantity && ti.quantity > 0).map((ticketType, index) =>
            ticketType.seatsIOObjects && ticketType.seatsIOObjects.length > 0 ? (
              ticketType.seatsIOObjects.map((object, objectIndex) =>
                <div className="row"
                     style={{"marginBottom": "12px"}}
                     key={objectIndex}>
                  <div className="col">
                    <p className="mb-0"
                       style={{"fontSize": "16px"}}>
                      {`${ticketType.name}: ${object.seat_assignment}`}
                    </p>
                  </div>
                  <div className="col-xs-auto text-right"
                       style={{"paddingRight": "15px"}}>
                    <p className="mb-0" style={{"fontSize": "16px"}}>
                      {ticketType.free ? (
                        <span>FREE</span>
                      ) : (
                        <span>{ticketType.price_to_currency}</span>
                      )}
                    </p>
                  </div>
                </div>
              )
            ) : (
              <div className="row"
                   style={{"marginBottom": "12px"}}
                   key={index}>
                <div className="col">
                  <p className="mb-0"
                     style={{"fontSize": "16px"}}>
                    {ticketType.quantity} x {ticketType.name}
                  </p>
                </div>
                <div className="col-xs-auto text-right"
                     style={{"paddingRight": "15px"}}>
                  <p className="mb-0" style={{"fontSize": "16px"}}>
                    {ticketType.free ? (
                      <span>FREE</span>
                    ) : (
                      <span>{ticketType.price_to_currency}</span>
                    )}
                  </p>
                </div>
              </div>
            )
          )}
          {addOns.filter((ao) => ao.quantity && ao.quantity > 0).map((addOn, index) =>
            addOn.seatsIOObjects && addOn.seatsIOObjects.length > 0 ? (
              addOn.seatsIOObjects.map((object, objectIndex) =>
                <div className="row"
                     style={{"marginBottom": "12px"}}
                     key={objectIndex}>
                  <div className="col">
                    <p className="mb-0"
                       style={{"fontSize": "16px"}}>
                      {`${addOn.name}: ${object.seat_assignment}`}
                    </p>
                  </div>
                  <div className="col-xs-auto text-right"
                       style={{"paddingRight": "15px"}}>
                    <p className="mb-0" style={{"fontSize": "16px"}}>
                      <span>{addOn.price_to_currency}</span>
                    </p>
                  </div>
                </div>
              )
            ) : (
              <div className="row"
                   style={{"marginBottom": "12px"}}
                   key={index}>
                <div className="col">
                  <p className="mb-0"
                     style={{"fontSize": "16px"}}>
                    {addOn.quantity} x {addOn.name}
                  </p>
                </div>
                <div className="col-xs-auto text-right"
                     style={{"paddingRight": "15px"}}>
                  <p className="mb-0" style={{"fontSize": "16px"}}>
                    <span>{addOn.price_to_currency}</span>
                  </p>
                </div>
              </div>
            )
          )}
          <hr style={{"borderTop": "1px solid var(--od-c-ececec, #ececec)"}} />
          <div className="row"
               style={{"marginBottom": "12px"}}>
            <div className="col">
              <p className="mb-0"
                 style={{"fontSize": "16px"}}>
                Subtotal
              </p>
            </div>
            <div className="col-xs-auto text-right"
                 style={{"paddingRight": "15px"}}>
              <p className="mb-0" style={{"fontSize": "16px"}}>
                {formatter.format(ticketReservation.subtotal_with_discount)}
              </p>
            </div>
          </div>
          {(ticketReservation.abstract_order_items || []).map((abstractOrderItem, index) =>
            <div className="row"
                 style={{"marginBottom": "12px"}}
                 key={index}>
              <div className="col">
                <p className="mb-0"
                   style={{"fontSize": "16px"}}>
                  {abstractOrderItem.quantity} x {abstractOrderItem.price_to_currency} {abstractOrderItem.name}
                </p>
              </div>
              <div className="col-xs-auto text-right"
                   style={{"paddingRight": "15px"}}>
                <p className="mb-0" style={{"fontSize": "16px"}}>
                  <span>{abstractOrderItem.summed_price_to_currency}</span>
                </p>
              </div>
            </div>
          )}
          <div className="row"
               style={{"marginBottom": "12px"}}>
            <div className="col">
              <p className="mb-0"
                 style={{"fontSize": "16px"}}>
                Fees
              </p>
            </div>
            <div className="col-xs-auto text-right"
                 style={{"paddingRight": "15px"}}>
              <p className="mb-0" style={{"fontSize": "16px"}}>
                {formatter.format(ticketReservation.fees)}
              </p>
            </div>
          </div>
          {parseFloat(ticketReservation.taxes) > 0.00 ? (
            <div className="row"
                 style={{"marginBottom": "12px"}}>
              <div className="col">
                <p className="mb-0"
                   style={{"fontSize": "16px"}}>
                  Taxes
                </p>
              </div>
              <div className="col-xs-auto text-right"
                   style={{"paddingRight": "15px"}}>
                <p className="mb-0" style={{"fontSize": "16px"}}>
                  {formatter.format(ticketReservation.taxes)}
                </p>
              </div>
            </div>
          ) : null}
          <hr style={{"borderTop": "1px solid var(--od-c-ececec, #ececec)"}} />
          <div className="row"
               style={{"marginBottom": "12px"}}>
            <div className="col">
              <p className="mb-0"
                 style={{"fontSize": "16px"}}>
                <strong>Total</strong>
              </p>
            </div>
            <div className="col-xs-auto text-right"
                 style={{"paddingRight": "15px"}}>
              <p className="mb-0" style={{"fontSize": "16px"}}>
                <strong>{formatter.format(ticketReservation.total)}</strong>
              </p>
            </div>
          </div>
          {(ticketReservation.applied_gift_card_summaries || []).length > 0 ? (
            <>
              {ticketReservation.applied_gift_card_summaries.map((card) =>
                <div className="row applied-gift-card-total"
                     style={{"marginBottom": "12px"}}
                     key={card.id}>
                  <div className="col">
                    <p className="mb-0" style={{"fontSize": "16px"}}>
                      Gift card •••• {card.code_last4}
                    </p>
                  </div>
                  <div className="col-xs-auto text-right"
                       style={{"paddingRight": "15px"}}>
                    <p className="mb-0" style={{"fontSize": "16px"}}>
                      −{formatter.format(card.amount_cents / 100)}
                    </p>
                  </div>
                </div>
              )}
              <hr style={{"borderTop": "1px solid var(--sl-border-secondary)"}} />
              <div className="row"
                   style={{"marginBottom": "12px"}}>
                <div className="col">
                  <p className="mb-0" style={{"fontSize": "16px"}}>
                    <strong>Left to collect</strong>
                  </p>
                </div>
                <div className="col-xs-auto text-right"
                     style={{"paddingRight": "15px"}}>
                  <p className="mb-0" style={{"fontSize": "16px"}}>
                    <strong>{formatter.format(ticketReservation.gift_card_adjusted_total)}</strong>
                  </p>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    ) : null}
  </div>
);

TotalsTable.propTypes = {
  ticketTypes: PropTypes.array.isRequired,
  ticketReservation: PropTypes.object,
  addOns: PropTypes.array
};

export default TotalsTable;
